// packages/shared-hooks/src/clients/useAddClientContact.ts
//
// `POST /clients/:id/contacts` — adds a contact to an active client.
// Returns one `ClientContact`; the parent detail must refetch so the new
// row joins the contacts array under the correct (primary-first) ordering.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ClientContactSchema, type ClientContact, type ClientContactInput } from '@magimp/shared';
import { useApiClient } from '../api/context.js';
import { clientsKeys } from './keys.js';

export function useAddClientContact(clientId: string) {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<ClientContact, unknown, ClientContactInput>({
    mutationFn: (input) =>
      client.post<ClientContact>(`/clients/${clientId}/contacts`, input, {}, ClientContactSchema),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: clientsKeys.detail(clientId) });
      void qc.invalidateQueries({ queryKey: clientsKeys.all });
    },
  });
}
